const REMEMBERED_EMAIL_KEY = 'loginRememberedEmail';

export const getRememberedEmail = (): string => {
  try {
    return window.localStorage.getItem(REMEMBERED_EMAIL_KEY) ?? '';
  } catch {
    // localStorage unavailable (blocked, private mode).
    return '';
  }
};

export const saveRememberedEmail = (email: string, remember: boolean): void => {
  try {
    if (remember) {
      window.localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    } else {
      window.localStorage.removeItem(REMEMBERED_EMAIL_KEY);
    }
  } catch {
    // Best effort: failing to persist must never block sign-in.
  }
};
